var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"ma-0 loading",attrs:{"active":_vm.isShow,"color":"light-blue","indeterminate":true,"height":"6"}})}
var staticRenderFns = []

export { render, staticRenderFns }